import { FC } from 'react';
import { Modal, ModalProps } from 'antd';
import { Button, ButtonProps } from '@base/lib/Button';

export type ITransparentModalProps = Omit<ModalProps, 'okButtonProps' | 'cancelButtonProps'> & {
    okButtonProps?: ButtonProps;
    cancelButtonProps?: ButtonProps;
};

export const TransparentModal: FC<ITransparentModalProps> = props => {
    const {
        className,
        width = 275,
        onCancel,
        okButtonProps,
        cancelButtonProps,
        ...rest
    } = props;

    return (
        <Modal
            className={className}
            width={width}
            onCancel={onCancel}
            centered
            closable={false}
            maskStyle={{ background: 'rgba(0, 0, 0, 0.9)' }}
            maskClosable={!okButtonProps && !cancelButtonProps}
            footer={!okButtonProps && !cancelButtonProps ? null : (
                <>
                    {!!okButtonProps && (
                        <Button
                            type={'primary'}
                            block
                            onClick={onCancel}
                            {...okButtonProps}
                        />
                    )}
                    {!!cancelButtonProps && (
                        <Button
                            type={'d'}
                            block
                            onClick={onCancel}
                            {...cancelButtonProps}
                        />
                    )}
                </>
            )}
            {...rest}
        />
    )
};